/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomersIdGet200ResponsePersonalDetails from './CustomersIdGet200ResponsePersonalDetails';
import CustomersIdGet200ResponseServicesInner from './CustomersIdGet200ResponseServicesInner';

/**
 * The CustomersIdGet200Response model module.
 * @module model/CustomersIdGet200Response
 * @version 1.0.0
 */
class CustomersIdGet200Response {
    /**
     * Constructs a new <code>CustomersIdGet200Response</code>.
     * @alias module:model/CustomersIdGet200Response
     */
    constructor() { 
        
        CustomersIdGet200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdGet200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdGet200Response} obj Optional instance to populate.
     * @return {module:model/CustomersIdGet200Response} The populated <code>CustomersIdGet200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdGet200Response();

            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'String');
            }
            if (data.hasOwnProperty('personalDetails')) {
                obj['personalDetails'] = CustomersIdGet200ResponsePersonalDetails.constructFromObject(data['personalDetails']);
            }
            if (data.hasOwnProperty('services')) {
                obj['services'] = ApiClient.convertToType(data['services'], [CustomersIdGet200ResponseServicesInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdGet200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdGet200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['accountId'] && !(typeof data['accountId'] === 'string' || data['accountId'] instanceof String)) {
            throw new Error("Expected the field `accountId` to be a primitive type in the JSON string but got " + data['accountId']);
        }
        // validate the optional field `personalDetails`
        if (data['personalDetails']) { // data not null
          CustomersIdGet200ResponsePersonalDetails.validateJSON(data['personalDetails']);
        }
        if (data['services']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['services'])) {
                throw new Error("Expected the field `services` to be an array in the JSON data but got " + data['services']);
            }
            // validate the optional field `services` (array)
            for (const item of data['services']) {
                CustomersIdGet200ResponseServicesInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} accountId
 */
CustomersIdGet200Response.prototype['accountId'] = undefined;

/**
 * @member {module:model/CustomersIdGet200ResponsePersonalDetails} personalDetails
 */
CustomersIdGet200Response.prototype['personalDetails'] = undefined;

/**
 * @member {Array.<module:model/CustomersIdGet200ResponseServicesInner>} services
 */
CustomersIdGet200Response.prototype['services'] = undefined;






export default CustomersIdGet200Response;

